import { dayjs, isEmpty, omitBy } from '@revolugo/common/utils'
import { lightTheme } from '@revolugo/elements-vue3'

import type { RevolugoConfig } from '@revolugo/elements-vue3'
import type { PublicEvent, PublicSetting } from '@revolugo/graphql/public'

export const DEFAULT_THEME: RevolugoConfig['theme'] = lightTheme.colors

export const buildElementsConfig = ({
  event,
  eventMetadataOverride,
  metadata,
  organizationId,
  setting,
  theme,
  trackingId,
  wid,
}: {
  event?: PublicEvent
  eventMetadataOverride?: RevolugoConfig['eventMetadata']
  metadata?: Record<string, string>
  organizationId?: string
  setting?: PublicSetting
  theme?: Partial<RevolugoConfig['theme']>
  trackingId?: string
  wid?: string
  // eslint-disable-next-line complexity
}): Partial<RevolugoConfig> => {
  const config: Partial<RevolugoConfig> = {
    eventMetadata:
      wid && trackingId
        ? {
            id: wid,
            slug: wid,
          }
        : undefined,
    metadata,
    organizationId,
    trackingId,
  }

  const configTheme: RevolugoConfig['theme'] = {
    ...DEFAULT_THEME,
  }

  if (setting) {
    config.organizationId = config.organizationId || setting.organizationId

    config.eventMetadata = {
      ...config.eventMetadata,
      dateEnd:
        (event?.eventDateTo && dayjs(event.eventDateTo).format('YYYY-MM-DD')) ||
        undefined,
      dateStart:
        (event?.eventDateFrom &&
          dayjs(event.eventDateFrom).format('YYYY-MM-DD')) ||
        undefined,
      imageURL: (event && event.markerPicture!) || undefined,
      name: event?.name,
      slug: setting.slug,
    }

    if (setting.colorPrimary) {
      configTheme.primary = setting.colorPrimary
    }
    if (setting.colorSecondary) {
      configTheme.secondary = setting.colorSecondary
    }
    if (setting.colorHotelMarkerPrimary) {
      configTheme.markerPrimary = setting.colorHotelMarkerPrimary
    }
    if (setting.colorHotelMarkerSecondary) {
      configTheme.markerSecondary = setting.colorHotelMarkerSecondary
    }
  }

  if (eventMetadataOverride) {
    config.eventMetadata = {
      ...config.eventMetadata,
      ...omitBy(eventMetadataOverride, isEmpty),
    } as RevolugoConfig['eventMetadata']
  }

  if (theme) {
    configTheme.primary = theme.primary || configTheme.primary
    configTheme.secondary = theme.secondary || configTheme.secondary
    configTheme.markerPrimary = theme.markerPrimary || configTheme.markerPrimary
    configTheme.markerSecondary =
      theme.markerSecondary || configTheme.markerSecondary
  }

  config.theme = configTheme

  return config
}
